import React from 'react';
import { Modal, Box, IconButton, Tooltip } from '@mui/material';
import { Close, Download } from '@mui/icons-material';

const ImagePreviewModal = ({ open, imageUrl, onClose }) => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_BACKEND}${imageUrl}`;
    link.download = imageUrl.split('/').pop() || 'document';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          maxWidth: '90vw',
          maxHeight: '90vh',
          outline: 'none',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 1,
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 1,
            bgcolor: 'background.paper',
            '&:hover': {
              bgcolor: 'background.paper',
            },
          }}
        >
          <Close />
        </IconButton>

        {/* Download Button */}
        <Tooltip title="Download" arrow>
          <IconButton
            onClick={handleDownload}
            sx={{
              position: 'absolute',
              right: 48,
              top: 8,
              zIndex: 1,
              bgcolor: 'background.paper',
              '&:hover': {
                bgcolor: 'background.paper',
              },
            }}
          >
            <Download />
          </IconButton>
        </Tooltip>

        {/* Image Container */}
        <Box
          sx={{
            maxWidth: '100%',
            maxHeight: 'calc(90vh - 32px)',
            overflow: 'auto',
            borderRadius: 2,
          }}
        >
          <img
            src={`${process.env.REACT_APP_BACKEND}${imageUrl}`}
            alt="Preview"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              borderRadius: 4,
            }}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ImagePreviewModal;